import React from "react"
import { Col, Row, Container } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons"
import '../styles/home.scss'

const CallSection = () => {
  return (
    <section id="call-section">
      <Container>
        <Row className="bg-white">
          <Col md={6} className="pr-3">
            <h2>Call us to get help right now</h2>
          </Col>
          <Col md={6}>
            <button className="phone-btn btn">
              <FontAwesomeIcon icon={faPhoneAlt} style={{marginRight:"1rem"}}/>
              (347)023-1821
            </button>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default CallSection
